module.exports = __webpack_public_path__ + "static/media/pulverizador.ec841f35.svg";